var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testimonial-item-3",class:[_vm.container, _vm.cols('', 'mb-4')],style:({..._vm.padding, ..._vm.shadow})})
}
var staticRenderFns = []

export { render, staticRenderFns }